export default class Framebuffer {

    constructor() {
        //
    }

    renderTo(renderCallback) {
        
        if (!renderCallback)
            throw new Error("Unable to render to framebuffer, invalid callback argument.");

        renderCallback();
    }
}